<template>
  <ElButton
    type="warning"
    @click="showDialog()"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <el-select v-model="position" placeholder="Select a Position" filterable>
          <el-option v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="position == null"
          @click="changeAvailableLinks()"
        >
          Download
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
// import axios from '@/axios/axios'

export default {
  name: 'AdvancedReport',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      updateLinks: null,
      position: null
    }
  },
  computed: {
    options() {
      return this.$store.getters.profilePositionsData
    },
    title() {
      return 'ADVANCED REPORT'
    },

    profile() {
      return this.user.profile
    },

    links() {
      return this.profile.availableLinks
    }
  },
  methods: {
    async showDialog() {
      await this.getProfilePositions();
      this.updateLinks = this.links
      this.showForm = true
    },

    getProfilePositions() {
      this.$store.dispatch('getProfilePositions', {id: this.profile.id})
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
      var view = new Uint8Array(buf);  // create uint8array as viewer
      for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; // convert to octet
      return buf; 
    },
    changeAvailableLinks() {
      // const data = {
      //   position_id: this.position,
      // }

      const proxyURL = process.env.VUE_APP_PROXY

      window.open(`${proxyURL}export/advanced/excel?position_id=${this.position}`, '_blank');

      // axios.get(`${proxyURL}export/advanced/excel`, {params: data}, {responseType: 'blob'})
      //   .then(res => {
      //     const url = URL.createObjectURL(new Blob([res.data]))
      //     const link = document.createElement('a')
      //     link.href = url
      //     link.setAttribute('download', 'report.xlsx')
      //     document.body.appendChild(link)
      //     link.click()
      //   })
      //   .catch(axios.handleError)
    }
  }
}
</script>
